jQuery(document).ready(function ($) {
  $("#customize-box-btn").on("click", function () {
    $("section.mother-gift-pdp").addClass("open-customize-box");
    $('html, body').animate({scrollTop:0},500);
  });

  // Step Event
  $("#customize-gift-step-status").on("change", function () {
    var step = $(this).val(),
      boxTitle = $(
        '.gift-customize-content .custom-box[data-custom-box="' + step + '"]'
      ).data("box-title"),
      boxContent = $(
        '.gift-customize-content .custom-box[data-custom-box="' + step + '"]'
      ).data("box-content");

    $(".gift-customize-content .custom-box").removeClass("active");
    $(
      '.gift-customize-content .custom-box[data-custom-box="' + step + '"]'
    ).addClass("active");

    $(".step-bar-wrap .step").removeClass("active");
    $('.step-bar-wrap .step[data-step="' + step + '"]').addClass("active");
    $(".customize-gift-steps-wrap .step-number .count").text(step);
    $(".customize-gift-steps-wrap .step-title").text(boxTitle);
    $(".customize-gift-steps-wrap .step-content").text(boxContent);
  });

  document.addEventListener("product:variant-change", function (event) {
    var sectionID = event.detail.sectionId,
      variantID = event.detail.variant.id;

    $("#variant-selects-" + sectionID)
      .parent(".gift-product-item")
      .find(".gift-variant-id")
      .val(variantID);
  });

  // Gift Packaging
  /*
  $('.gift-packaging .gift-product-item .add-to-cart').on('click', function() {
    var $this = $(this),
        stepNum = $('#customize-gift-step-status').val(),
        giftItem = $this.parents('.gift-product-item'),
        giftTitle = giftItem.find('.product-title').text(),
        giftPrice = giftItem.find('.product-price').text(),
        giftPriceVal = parseFloat(giftItem.find('.product-price').data('price')),
        subTotal = parseFloat($('.mother-gift-information .gift-subtotal .price').attr('data-price')),
        variantID = giftItem.find('.gift-variant-id').val();

    $('#packaging-step-val').val(variantID);
    $('#customize-gift-step-status').val(parseInt(stepNum) + 1).trigger('change');

    var giftHtml = '<div class="extra-item"><span class="extra-title">'+ giftTitle +'</span><span class="extra-price">'+ giftPrice +'</span></div>';
    $('.mother-gift-information .extras-list').append(giftHtml);
    $('.mother-gift-information .content-item[data-content="1"]').append('<span> : '+ giftTitle +'</span>').addClass('passed');

    var updatedPrice = '$' + (subTotal + giftPriceVal).toFixed(2);
    $('.mother-gift-information .gift-subtotal .price').attr('data-price', subTotal + giftPriceVal);
    $('.mother-gift-information .gift-subtotal .price').text(updatedPrice);
    $("html, body").animate({ scrollTop: "0" }, 80); 
  });
  */

  // Customize Items
  $(".customize-items .add-to-cart").on("click", function () {
    var $this = $(this),
      stepNum = $("#customize-gift-step-status").val(),
      giftItem = $this.parents(".gift-product-item"),
      giftPriceVal = parseFloat(giftItem.find(".product-price").data("price")),
      subTotal = parseFloat(
        $(".mother-gift-information .gift-subtotal .price").attr("data-price")
      ),
      variantID = giftItem.find(".gift-variant-id").val(),
      productID = giftItem.find(".gift-variant-id").data("product-id"),
      uploads = giftItem.find(".gift-uploads").val();

    if ($this.hasClass("disabled")) {
      // $('.customize-items').addClass('active-popup active-upload-notify-popup');
      return;
    }

    var variantName = "";
    if (giftItem.find(".variations").length > 0) {
      variantName = " : ";
      giftItem.find(".variations input:checked").each(function (index) {
        variantName = variantName + $(this).val();
        if (giftItem.find(".variations input:checked").length - 1 > index) {
          variantName = variantName + ", ";
        }
      });
    }

    if (!giftItem.hasClass("added")) {
      $(
        '.mother-gift-information .content-item[data-content="1"][data-item-id="' +
          productID +
          '"]'
      )
        .append("<span>" + variantName + "</span>")
        .addClass("passed");
      $('.customize-step-val[data-item-id="' + productID + '"]').val(variantID);
      $('.customize-step-val[data-item-id="' + productID + '"]').attr(
        "data-uploads",
        uploads
      );

      var updatedPrice = "$" + (subTotal + giftPriceVal).toFixed(2);
      $(".mother-gift-information .gift-subtotal .price").attr(
        "data-price",
        subTotal + giftPriceVal
      );
      $(".mother-gift-information .gift-subtotal .price").text(updatedPrice);

      giftItem.addClass("added");
      $this.prop("disabled", true).text("ADDED");

      // $('.customize-items').addClass('active-popup active-item-notify-popup');
    }

    if (
      $(".customize-items .gift-product-item").length ==
      $(".customize-items .added").length
    ) {
      $("#customize-gift-step-status")
        .val(parseInt(stepNum) + 1)
        .trigger("change");
      $("html, body").animate({ scrollTop: "0" }, 80);
      $('.step[data-step="1"]').addClass("passed");
    }
  });

  // Gift Details
  $(".gift-details .add-to-cart").on("click", function () {
    var $this = $(this),
      stepNum = $("#customize-gift-step-status").val(),
      giftItem = $this.parents(".gift-product-item"),
      giftPriceVal = parseFloat(giftItem.find(".product-price").data("price")),
      subTotal = parseFloat(
        $(".mother-gift-information .gift-subtotal .price").attr("data-price")
      ),
      variantID = giftItem.find(".gift-variant-id").val();

    var variantName = "";
    if (giftItem.find(".variations").length > 0) {
      variantName = " : ";
      giftItem.find(".variations input:checked").each(function (index) {
        variantName = variantName + $(this).val();
        if (giftItem.find(".variations input:checked").length - 1 > index) {
          variantName = variantName + ", ";
        }
      });
    }

    var updatedPrice = "$" + (subTotal + giftPriceVal).toFixed(2);
    $(".mother-gift-information .gift-subtotal .price").attr(
      "data-price",
      subTotal + giftPriceVal
    );
    $(".mother-gift-information .gift-subtotal .price").text(updatedPrice);
    $('.mother-gift-information .content-item[data-content="2"]')
      .append("<span>" + variantName + "</span>")
      .addClass("passed");
    $('.step[data-step="2"]').addClass("passed");
    $("#details-step-val").val(variantID);
    $("#customize-gift-step-status")
      .val(parseInt(stepNum) + 1)
      .trigger("change");
    $("html, body").animate({ scrollTop: "0" }, 80);

    $(this).addClass("disabled");
    $(this).text("ADDED");

    if (giftPriceVal > 0) {
      let giftTitle = giftItem.find(".product-title").text();
      let giftPrice = "$" + giftPriceVal;
      let giftHtml =
        '<div class="extra-item"><span class="extra-title">' +
        giftTitle +
        '</span><span class="extra-price">' +
        giftPrice +
        "</span></div>";
      $(".mother-gift-information .extras-list").append(giftHtml);
    }
  });

  // Gift Tag or Card
  $(".gift-cards .customize-card").on("click", function () {
    var $this = $(this),
      giftItem = $this.parents(".gift-product-item"),
      giftPriceVal = parseFloat(giftItem.find(".product-price").data("price")),
      giftTitle = giftItem.find(".product-title").text(),
      giftImg = giftItem.find(".product-image").attr("src"),
      variantID = giftItem.find(".gift-variant-id").val();

    $(".card-image-wrap .card-title").text(giftTitle);
    $(".card-image-wrap .card-image").attr("src", giftImg);
    $(".gift-card-change .change-card-id").val(variantID);
    $(".gift-card-change .change-card-id").attr("data-price", giftPriceVal);
    $(".gift-customize-content .gift-cards").addClass("open-customizer");
  });

  $(".gift-card-change .add-to-cart").on("click", function () {
    var $this = $(this),
      stepNum = $("#customize-gift-step-status").val(),
      giftPrice = parseFloat(
        $this
          .parents(".card-textarea-wrap")
          .find(".change-card-id")
          .data("price")
      ),
      subTotal = parseFloat(
        $(".mother-gift-information .gift-subtotal .price").attr("data-price")
      ),
      cardID = $this
        .parents(".card-textarea-wrap")
        .find(".change-card-id")
        .val();

    var updatedPrice = "$" + (subTotal + giftPrice).toFixed(2);
    $(".mother-gift-information .gift-subtotal .price").attr(
      "data-price",
      subTotal + giftPrice
    );
    $(".mother-gift-information .gift-subtotal .price").text(updatedPrice);
    $("#tag-card-val").val(cardID);
    $('.mother-gift-information .content-item[data-content="3"]').addClass(
      "passed"
    );
    $('.step[data-step="3"]').addClass("passed");
    /*$('#customize-gift-step-status').val(parseInt(stepNum) + 1).trigger('change');*/
    /*$("html, body").animate({ scrollTop: "0" }, 80); */

    window.custom_gift_info = [];
    $(".mother-giftbox-inner .add-to-cart-gift-box").removeAttr("disabled");

    // Add gift values
    window.custom_gift_info.push({
      id: $('gift-product-form input[name="id"]').val(),
    });
    /*window.custom_gift_info.push({ id: $('#packaging-step-val').val() });*/
    $(".customize-step-val").each(function () {
      window.custom_gift_info.push({
        id: $(this).val(),
        uploads: $(this).data("uploads"),
      });
    });
    window.custom_gift_info.push({ id: $("#details-step-val").val() });

    var cardMessage = "";
    if ($("#leave-print-message").is(":checked")) {
      cardMessage = "The customer would like to write their own message.";
    } else {
      cardMessage = $(".gift-card-change .card-print-message").val();
    }
    window.custom_gift_info.push({
      id: $("#tag-card-val").val(),
      print_msg: cardMessage,
      to_msg: $('.gift-card-change .card-print-input[name="to"]').val(),
      from_msg: $('.gift-card-change .card-print-input[name="from"]').val()
    });

    if (giftPrice > 0) {
      let giftTitle = $this
        .parents(".gift-card-change")
        .find(".card-title")
        .text();
      let giftPriceMoney = "$" + giftPrice;
      let giftHtml =
        '<div class="extra-item"><span class="extra-title">' +
        giftTitle +
        '</span><span class="extra-price">' +
        giftPriceMoney +
        "</span></div>";
      $(".mother-gift-information .extras-list").append(giftHtml);
    }

    // Add items to cart
    $(".add-to-cart-gift-box").trigger("click");
  });

  // Click Step
  $(document).on("click", ".step-bar-wrap .step", function () {
    let clickedStep = parseInt($(this).data("step"));
    if (
      (clickedStep >= 2 &&
        $(`.step-bar-wrap .step[data-step="${clickedStep - 1}"]`).hasClass(
          "passed"
        )) ||
      $(this).hasClass("passed")
    ) {
      $(".step.active").removeClass("active");
      $(this).addClass("active");
      $(".custom-box.active").removeClass("active");
      $(`.custom-box[data-custom-box="${clickedStep}"]`).addClass("active");
      $("#customize-gift-step-status").val(clickedStep);
    } else if (
      clickedStep == 2 &&
      !$(`.step-bar-wrap .step[data-step="1"]`).hasClass("passed")
    ) {
      $('[data-custom-box="1"]').addClass(
        "active-popup active-item-notify-popup"
      );
    }
  });

  // Tag/Card Change
  $(".card-change").on("click", function () {
    $(".gift-cards").removeClass("open-customizer");
  });

  // Gift Add to Cart
  $(".mother-giftbox-inner .add-to-cart-gift-box").on("click", function () {
    var $this = $(this),
      cartParams = [];

    if ($this.prop("disabled")) return;

    for (let i = window.custom_gift_info.length - 1; i >= 0; i--) {
      if (window.custom_gift_info[i].print_msg) {
        cartParams.push({
          id: window.custom_gift_info[i].id,
          quantity: 1,
          properties: {
            "Print Message": window.custom_gift_info[i].print_msg,
            To: window.custom_gift_info[i].to_msg,
            From: window.custom_gift_info[i].from_msg,
          },
        });
      } else if (window.custom_gift_info[i].uploads) {
        cartParams.push({
          id: window.custom_gift_info[i].id,
          quantity: 1,
          properties: {
            Uploads: window.custom_gift_info[i].uploads,
          },
        });
      } else {
        cartParams.push({
          id: window.custom_gift_info[i].id,
          quantity: 1,
        });
      }
    }

    // console.log("-------cartParams", cartParams);

    $this.addClass("loading");

    $.ajax({
      // Clear cart
      type: "POST",
      url: "/cart/clear.js",
      success: function () {
        $.ajax({
          // Add items to Cart
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: cartParams,
          },
          dataType: "json",
          success: function () {
            window.location.href = "/cart";
          },
        });
      },
    });
  });

  // Popup
  $(".custom-box-popup .button").on("click", function () {
    $(this)
      .parents(".custom-box")
      .removeClass(
        "active-popup active-upload-notify-popup active-item-notify-popup"
      );
  });

  // Text Characters Calculation
  var max_length = 200;
  $(".card-textarea-wrap .card-print-message").keydown(function () {
    var len = max_length - $(this).val().length;
    $(".card-textarea-wrap .GFG").text(len);
  });

  if ($(`[role="uploadcare-uploader"]`).length) {
    $(`[role="uploadcare-uploader"]`).each(function () {
      let productId = $(this).attr("data-product-id");
      let widget = uploadcare.Widget(
        `[role=uploadcare-uploader][data-product-id="${productId}"]`,
        { publicKey: "24513c94064f90994a31" }
      );
      widget.inputElement.nextSibling.querySelector(
        ".uploadcare--widget__button_type_open"
      ).innerHTML = "Choose Images";
      widget.onChange(function (group) {
        if (group.files().length == widget.inputElement.dataset.multipleMax) {
          widget.inputElement.parentNode
            .querySelector(".add-to-cart")
            .classList.remove("disabled");
        } else {
          widget.inputElement.parentNode
            .querySelector(".add-to-cart")
            .classList.add("disabled");
        }
      });
    });
  }
});
